module.exports = __webpack_public_path__ + "img/aavedown.bb61d162.svg";